import { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FieldsFilter, Grid, InputSearch } from 'src/components/UI'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { estimatesActions } from 'src/ducks/actions'
import { getClientData, getEstimatesForTable } from 'src/ducks/selectors'
import { EstimateItem } from 'src/ducks/types'
import headers from './headers'

const Estimates: FC = () => {
    const dispatch = useDispatch()
    const userData = useSelector(getClientData())
    const clientId = userData?.id
    const allEstimates = useSelector(getEstimatesForTable())
    
    const [loading, setLoading] = useState(false)
    const [searchFilter, setSearchFilter] = useState('')
    const [tableHeaders, setTableHeaders] = useState(headers)

    const onTableFilterChange = (index: number): void => {
        setTableHeaders(tableHeaders.map((item, indx) => {
            if (indx === index) {
                return { ...item, hide: !item.hide }
            }
            return item
        }))
    }

    const fetchEstimates = useCallback(() => {
        if (clientId) {
            setLoading(true)
            dispatch(
                estimatesActions.fetchEstimates(
                    { 
                        page: 0, 
                        size: 100, 
                        searchParams: { 
                            clientId: clientId,
                        } 
                    }, 
                    (_succ: boolean) => {
                        setLoading(false)
                    }
                )
            )
        }
    }, [clientId, dispatch])

    useEffect(() => {
        fetchEstimates()
    }, [fetchEstimates])

    // Filter estimates based on search
    const filteredEstimates = allEstimates.filter((estimate: EstimateItem) => {
        if (!searchFilter) return true
        const searchLower = searchFilter.toLowerCase()
        return (
            estimate.properties?.publicId?.toLowerCase().includes(searchLower) ||
            estimate.properties?.fullAddress?.toLowerCase().includes(searchLower) ||
            estimate.properties?.address?.city?.toLowerCase().includes(searchLower)
        )
    })

    // Transform data to include needed fields
    const tableData = filteredEstimates.map((estimate: EstimateItem) => ({
        ...estimate,
        publicId: estimate.properties?.publicId || '-',
        fullAddress: estimate.properties?.fullAddress || '-',
        city: estimate.properties?.address?.city || '-',
        state: estimate.properties?.address?.state || '-',
        zipCode: estimate.properties?.address?.zipCode || '-',
        territory: estimate.properties?.territory?.title || '-',
        totalValue: estimate.properties?.totalValue ? `$${estimate.properties.totalValue.toFixed(2)}` : '$0.00',
    }))

    return (
        <Grid container>
            <Grid item flex={1}>
                <Grid container justifyContent="flex-end" spacing={2} marginBottom={2}>
                    <Grid item>
                        <InputSearch
                            placeholder='Search...'
                            onChange={setSearchFilter}
                            value={searchFilter}
                        />
                    </Grid>
                    <Grid item>
                        <FieldsFilter options={tableHeaders} handleChange={onTableFilterChange} />
                    </Grid>
                </Grid>
                <Table
                    headers={tableHeaders}
                    loading={loading}
                >
                    {tableData}
                </Table>
            </Grid>
        </Grid>
    )
}

export default Estimates

